const data = {
  sectionConfig: {
    padding: {
      desktop: '40px 0',
      tablet: '40px 0',
      mobile: '40px 0'
    }
  },
  company: 'Julia Beuther cosmetics',
  provider: 'IONOS',
  customCookieScriptTag: {
    id: 'CookieDeclaration',
    src:
      'https://consent.cookiebot.com/d82c5589-9da1-4b21-ab91-661139e96fa2/cd.js',
    type: 'text/javascript',
    async: true
  }
}

export default data
